import axios, { AxiosResponse } from 'axios';
import EnvWindow from '../../../utils/env';
import { IInstructionListResponse, IInstructionListItem } from './supportInstructions.types';
import { dataUrlToFile } from '../../../utils/servicesHelper';

const instructionUrl = `${EnvWindow.REACT_APP_SUPPORT_API_URL}/Instruction`;

export async function getInstructionsList(): Promise<AxiosResponse<IInstructionListResponse>> {
  return await axios.get(`${instructionUrl}/list`);
}

export async function getInstruction(instructionId: string): Promise<AxiosResponse<IInstructionListItem>> {
  return await axios.get(`${instructionUrl}/item/${instructionId}`);
}

const getInstructionRequestBody = async (
  title: string,
  description: string,
  htmlContent: string,
  images: string[],
): Promise<FormData> => {
  const requestBody = new FormData();
  requestBody.append('htmlContent', htmlContent);
  requestBody.append('title', title);
  requestBody.append('description', description);

  const allImagesPromisses = images.map(async (image, index) => {
    return dataUrlToFile(image, `img${index}.png`);
  });

  await Promise.all(allImagesPromisses).then((values) => {
    values.forEach((item) => requestBody.append('files', item));
  });
  return requestBody;
};

export async function createInstruction(
  title: string,
  description: string,
  htmlContent: string,
  images: string[],
): Promise<AxiosResponse<string>> {
  const requestBody = await getInstructionRequestBody(title, description, htmlContent, images);
  const response = await axios({
    method: 'POST',
    url: instructionUrl,
    headers: { 'Content-Type': 'multipart/form-data' },
    data: requestBody,
    // transformes response to string in order to prevent returning it as number which is rounded
    transformResponse: [
      function (data: string) {
        return data;
      },
    ],
  });

  return response;
}

export const likeInstruction = async (instructionId: string): Promise<AxiosResponse<boolean>> => {
  return await axios.put(instructionUrl + '/like', { id: instructionId });
};

export const dislikeInstruction = async (instructionId: string): Promise<AxiosResponse<boolean>> => {
  return await axios.put(instructionUrl + '/dislike', { id: instructionId });
};

export const deleteInstruction = async (instructionId: string): Promise<AxiosResponse<boolean>> => {
  return await axios.delete(instructionUrl, { data: { id: instructionId } });
};

export async function updateInstruction(
  id: string,
  title: string,
  description: string,
  htmlContent: string,
  images: string[],
): Promise<AxiosResponse> {
  const requestBody = await getInstructionRequestBody(title, description, htmlContent, images);
  requestBody.append('id', id);
  return await axios({
    method: 'PUT',
    url: instructionUrl,
    headers: { 'Content-Type': 'multipart/form-data' },
    data: requestBody,
  });
}
